import axios from "axios"
import { objectToUrl } from "../../../Utility/Plugins";

const CommentService = {
    get(payload = {}) {
        return axios.get(`work-approval/comments?${objectToUrl(payload)}`)
    },

    post(payload) {
        return axios.post('work-approval/comments', payload);
    },

    put(payload) {
        return axios.put(`work-approval/comments/${payload.id}`, payload);
    },

    delete(payload) {
        return axios.delete(`work-approval/comments/${payload.id}`, {
            data: payload
        });
    }
}

export {
    CommentService
}